import { SiteData } from "../Data/SiteData";

export default function CustomFontMenu({ siteData, }: { siteData: SiteData }) {

    const CustomFontOption = ({ url, label, onUpdate }: { url: string, label: string, onUpdate: Function }) => {


        let inURL = (url) ? url : "https://fonts.googleapis.com/css2?family=";
        return (


            <div className="flex-column " style={{ padding: "8px 0px" }}>

                <label className="w-full no-shrink" style={{ width: "100px" }}>{label}</label> <input type="text" className="w-full" defaultValue={inURL}


                    onInput={(e) => {
                        onUpdate((

                            e.target as any).value.replaceAll(" ", "+"))

                    }} placeholder="https://fonts.googleapis.com/css2?family=..."></input>

            </div>


        )
    }

    const isJsonFont = (font: string) => {
        return font.startsWith("{") || font.startsWith("family=");
    }

    let fonts = siteData.siteStyling.customFonts;
    let filterCount = fonts.filter(f => {

        return !isJsonFont(f);
    }).length;
    while (filterCount < 3) {

        fonts.push("");
        filterCount++;
    }
    siteData.siteStyling.customFonts = fonts;

    return (

        <div className="wb-input-group no-border">
            {
                fonts.map((f, i) => {

                    if (isJsonFont(f)) {
                        return null;
                    }

                    return <CustomFontOption url={f} key={f + i} label={"Custom Font " + (i + 1)} onUpdate={(f: string) => {

                        if (f == "https://fonts.googleapis.com/css2?family=" || "https://fonts.googleapis.com/css2?family=".includes(f))
                            f = "";

                        siteData.siteStyling.customFonts[i] = f;
                        siteData.isStylePublishDirty = true;
                        siteData.isStyleSaveDirty = true;
                        siteData.onUpdateStyle();

                    }} />
                })
            }
        </div>

    )











}